module.exports = __webpack_public_path__ + "static/img/logo@-banner.c8b93f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo@-banner.png
// module id = 0Ab5
// module chunks = 14